import { render } from "./CardVue.vue?vue&type=template&id=486ea410&scoped=true"
import script from "./CardVue.vue?vue&type=script&lang=js"
export * from "./CardVue.vue?vue&type=script&lang=js"

import "./CardVue.vue?vue&type=style&index=0&id=486ea410&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486ea410"]])

export default __exports__